import { BulkDeleteButton, Datagrid, DateField, Filter, ListProps, ReferenceField, ReferenceInput, SelectInput, TextField, TextInput } from 'react-admin';
import { CustomList } from '../../components';

const MessagesFilter = props => (
  <Filter {...props}>
    <TextInput label="Nome" source="name" />
    <TextInput label="E-mail" source="email" />
    <ReferenceInput
      label="Assunto"
      source="subject"
      reference="message-subjects"
      sort={{ field: 'name', order: 'ASC' }}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    
  </Filter>
);

const MessagesBulkActionButtons = props => (
  <>
    <BulkDeleteButton {...props} />
  </>
);

export default function MessagesList(props: ListProps) {
  return (
    <CustomList 
      {...props}
      filters={<MessagesFilter />}
      sort={{ field: 'createdAt', order: 'DESC' }}
    >
      <Datagrid rowClick="show">  
        <DateField 
          locales="pt-BR" 
          options={{ timeZone: 'UTC' }} 
          label="Enviado em" 
          source="createdAt" 
        />
        <ReferenceField
          label="Assunto"
          source="subject"
          reference="message-subjects"
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField label="Nome" source="name" />
        <TextField label="E-mail" source="email" />
        <TextField label="Telefone" source="phone" />
        
      </Datagrid>
    </CustomList>
  );
}